(function () {
  "use strict";

  function randomIndex(max) {
    if (max <= 1) return 0;

    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        return values[0] % max;
      }
    } catch (error) {
      // Fall back to Math.random below.
    }

    return Math.floor(Math.random() * max);
  }

  function shuffleCards(grid, cards) {
    if (!grid || !cards || cards.length < 2) return;

    var shuffled = cards.slice();

    for (var i = shuffled.length - 1; i > 0; i -= 1) {
      var j = randomIndex(i + 1);
      var temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }

    shuffled.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function init(section) {
    if (!section || section.dataset.sublimatedReady === "1") return;
    section.dataset.sublimatedReady = "1";

    var grid = section.querySelector("[data-vendor-grid]");

    var cards = Array.prototype.slice.call(
      section.querySelectorAll("[data-vendor-card]")
    );

    /*
     * Vendor-neutral page load:
     * - no designer is preselected
     * - no iframe loads automatically
     * - vendor card order is randomized once for this page load
     */
    shuffleCards(grid, cards);

    var buttons = Array.prototype.slice.call(
      section.querySelectorAll("[data-vendor-select]")
    );

    var platforms = section.querySelector("[data-platforms-section]");
    var shell = section.querySelector("[data-designer-shell]");
    var frameWrap = section.querySelector("[data-designer-frame-wrap]");
    var frame = section.querySelector("[data-designer-frame]");
    var loading = section.querySelector("[data-designer-loading]");
    var placeholder = section.querySelector("[data-designer-placeholder]");
    var title = section.querySelector("[data-designer-title]");
    var eyebrow = section.querySelector("[data-designer-eyebrow]");
    var guides = Array.prototype.slice.call(
      section.querySelectorAll("[data-vendor-guide]")
    );
    var changeVendor = section.querySelector("[data-change-vendor]");

    function setSelected(vendorId) {
      cards.forEach(function (card) {
        card.classList.toggle(
          "is-selected",
          !!vendorId &&
            card.getAttribute("data-vendor-card") === vendorId
        );
      });
    }

    function hideGuides() {
      guides.forEach(function (guide) {
        guide.hidden = true;
      });
    }

    function resetDesigner() {
      setSelected("");
      hideGuides();

      if (frame) {
        frame.removeAttribute("src");
      }

      if (loading) {
        loading.classList.remove("is-hidden");
      }

      if (frameWrap) {
        frameWrap.hidden = true;
      }

      if (placeholder) {
        placeholder.hidden = true;
      }

      if (shell) {
        shell.hidden = true;
      }

      if (eyebrow) {
        eyebrow.textContent = "Interactive Designer";
      }

      if (title) {
        title.textContent = "Custom Sublimated Apparel Designer";
      }
    }

    function openVendor(button, scrollIntoView) {
      if (!button || !frame || !frameWrap || !shell) return;

      var vendorId = String(button.dataset.vendorId || "").trim();
      var vendorName = String(button.dataset.vendorName || "").trim();
      var vendorUrl = String(button.dataset.vendorUrl || "").trim();

      setSelected(vendorId);

      guides.forEach(function (guide) {
        guide.hidden =
          String(guide.getAttribute("data-vendor-guide") || "") !== vendorId;
      });

      shell.hidden = false;

      if (eyebrow) {
        eyebrow.textContent =
          vendorId === "momentec"
            ? "Momentec FreeStyle Designer"
            : vendorId === "champro"
              ? "CHAMPRO Interactive Designer"
              : "Interactive Designer";
      }

      if (title) {
        title.textContent = vendorName || "Custom Sports Apparel Designer";
      }

      if (!vendorUrl) {
        if (placeholder) {
          placeholder.hidden = false;
          placeholder.innerHTML =
            "<div><strong>Designer connection not configured yet.</strong>" +
            "<span>Add this vendor’s secure Unisource/Azure embed URL in the Shopify Theme Editor.</span></div>";
        }

        frameWrap.hidden = true;

        if (scrollIntoView !== false) {
          shell.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        return;
      }

      if (placeholder) {
        placeholder.hidden = true;
      }

      frameWrap.hidden = false;

      if (loading) {
        loading.classList.remove("is-hidden");
      }

      frame.removeAttribute("src");
      frame.setAttribute("src", vendorUrl);

      if (scrollIntoView !== false) {
        shell.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    if (frame) {
      frame.addEventListener("load", function () {
        if (loading) {
          loading.classList.add("is-hidden");
        }
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        openVendor(button, true);
      });
    });

    cards.forEach(function (card) {
      var button = card.querySelector("[data-vendor-select]");
      if (!button || button.disabled || card.classList.contains("is-disabled")) {
        return;
      }

      card.setAttribute("tabindex", "0");
      card.setAttribute("role", "button");
      card.setAttribute(
        "aria-label",
        "Open " + String(button.dataset.vendorName || "designer")
      );

      card.addEventListener("click", function (event) {
        if (event.target.closest("button, a, input, select, textarea, label")) {
          return;
        }

        openVendor(button, true);
      });

      card.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") {
          return;
        }

        event.preventDefault();
        openVendor(button, true);
      });
    });

    if (changeVendor) {
      changeVendor.addEventListener("click", function () {
        resetDesigner();

        if (platforms) {
          platforms.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      });
    }

    /*
     * IMPORTANT:
     * Deliberately do not inspect or honor a default vendor.
     * Initial state always remains vendor-neutral.
     */
    resetDesigner();
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll("[data-sublimated-section]")
      .forEach(init);
  }

  window.addEventListener("message", function (event) {
    var data = event.data;

    if (
      !data ||
      typeof data !== "object" ||
      data.sender !== "UnisourceMomentecWrapper"
    ) {
      return;
    }

    if (data.type === "scrollToTop") {
      var selected = document.querySelector(
        '[data-sublimated-section] [data-vendor-card="momentec"].is-selected'
      );

      if (selected) {
        var shell = selected
          .closest("[data-sublimated-section]")
          .querySelector("[data-designer-shell]");

        if (shell) {
          shell.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }
    }

    if (data.type === "cartData") {
      document.dispatchEvent(
        new CustomEvent("unisource:momentec-design-data", {
          detail: data.payload || null
        })
      );
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
